import DeploymentDetailPage from '@/modules/quant/execution/deployment-detail-page';
import { requireCapability } from '@/utils/route-guards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/quant/execution/$deploymentId',
)({
  beforeLoad: () => requireCapability('quantLab'),
  component: RouteComponent,
});

function RouteComponent(): JSX.Element {
  const { deploymentId } = Route.useParams();
  return <DeploymentDetailPage deploymentId={deploymentId} />;
}
